var defaultOpts = {
    //系统ID
    systemId: 'dafs',
    //当前用户ID 邮箱前缀
    userId: '',
    //以下两个参数控制水印横向和纵向间距，调整参数即可调整水印密集程度
    //宽度上的间距，内部会根据文字长度自动获取一个宽度imgWidth再加上这个imgWidthDis  -->width = imgWidth + imgWidthDis
    imgWidthDis: 120,
    //高度上的间距，内部会根据文字长度自动获取一个高度imgHeight再加上这个imgWidthDis -->height = imgHeight + imgHeightDis
    imgHeightDis: 120,
    //文字样式，理论上不允许随意更改水印文字样式
    //只支持修改文字颜色和透明度
    textStyle: 'rgba(0,0,0,0.04)',
    //水印的z-index
    zIndex: 10000,
    //需要打水印的容器 El的position不能是static，如果是static会被默认改为relative，这样水印才会生效
    containerEl: document.body,
    //监视时间间隔
    time: 2500,
    //是否直接禁用掉鼠标右键Î
    disableContextMenu: false,
    //是否启用，不让其选择，默认不启用
    disableSelect: false,
    //不能选择的区域，传入一个原生dom元素
    disableSelectEl: '',
    //是否禁止拷贝
    disableCopy: false,
    //禁止复制的元素容器
    disableCopyEl: '',
};
function addWaterMark(userId) {
    var windowObj = window;
    var config = Object.assign({}, defaultOpts, {
        userId: userId,
    });
    windowObj.waterMark && windowObj.waterMark(config);
}
export default addWaterMark;
